/**
 * 産廃回収詳細 排出事業者編集
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements`

const manifest_management_verify_emission = {
  namespaced: true,
  actions: {
    /**
     * 変更確認
     * @param commit
     * @param id { number }
     * @param params { Object }
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/verifies/${id}/emissions`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          resolve(content)
        } )
      })
    },
  },
}
export default manifest_management_verify_emission
